import ResetPasswordPanel from './components/ResetPasswordPanel/ResetPasswordPanel';

const ResetPassword = () => <ResetPasswordPanel />;

export default ResetPassword;
